import { Navigate, Outlet, useLocation } from "react-router-dom";
import AppLayout from "../../layouts/AppLayout";
import { useAuth } from "../../context/AuthContext";

const PublicUserRoute = ({
  isNavVisible,
  isCollapsed,
  closeNav,
}) => {

  return (
    <AppLayout
      isNavVisible={isNavVisible}
      isCollapsed={isCollapsed}
      closeNav={closeNav}
    >
      <Outlet />
    </AppLayout>
  );
};

export default PublicUserRoute;